import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { authReducer }          from "../reducers/authReducer";
import { uiReducer }            from "../reducers/uiReducer";
import { configUsuariReducer }  from "../reducers/configUsuariReducer";
import { configAplicacioReducer } from "../reducers/configAplicacioReducer";
import { configFormularioReducer } from "../reducers/configFormularioReducer";
import { adminReducer }         from "../reducers/adminReducer";
import thunk from 'redux-thunk';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const reducers = combineReducers({
    auth:             authReducer,
    ui:               uiReducer,
    configUsuari:     configUsuariReducer,
    configApp:        configAplicacioReducer,
    configFormulario: configFormularioReducer,
    adminUsuarios:    adminReducer,
});

export const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk))
);
